import {HorribleHeroesFreeSpinIntroView} from "../freeSpinIntro/HorribleHeroesFreeSpinIntroView";
import {TimelineLite} from "gsap";
import {HorribleHeroesGameMode} from "../../HorribleHeroesGameMode";

// #370
export class HHRestoreDuringFreeSpinView extends HorribleHeroesFreeSpinIntroView {

    // #370 -> no animation is required from super, so need to return empty Timeline otherwise, it will run animations.
    public getEndAnimation(): TimelineLite {
        return new TimelineLite();
    }

    // #370
    public getStartAnimation(prepareToEnterModeCallback: () => void, completeCallback: () => void): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            isMayhemMode: boolean = (this._gameData.getExpandedSymbol === "MX" || this._gameData.getScattersCollected === 5),
            fsMode: string = (this._gameData.nextMode === HorribleHeroesGameMode.FREESPIN_MID ? "LocknLoad" : "Toxic"),
            mayhemName: string = (isMayhemMode && fsMode === "LocknLoad") ? "Load" : fsMode;

        tl.add(() => {
            prepareToEnterModeCallback();

            this.startEndTransition(isMayhemMode, mayhemName, fsMode);
        }, 0);

        tl.add(() => this.endEndTransition(isMayhemMode, mayhemName, fsMode), 1.5);

        tl.add(() => {
            this.resetTransitionItems();

            completeCallback();
        }, 2);

        return tl;
    }
}